import { useSite, usePageMeta } from "@/lib/content";

export default function Legal({ page }) {
  const { data: site } = useSite();
  const isImp = page === "impressum";
  const text = (site && (isImp ? site.impressum_text : site.datenschutz_text)) || "";

  usePageMeta(
    isImp ? "Impressum — SEIMEN DEXTER" : "Datenschutzerklärung — SEIMEN DEXTER",
    isImp ? "Legal information about SEIMEN DEXTER." : "Privacy policy of the SEIMEN DEXTER website."
  );

  return (
    <div className="px-5 md:px-10 pt-28 md:pt-40 pb-24 md:pb-36 max-w-3xl">
      <p className="kicker mb-6">{isImp ? "LEGAL" : "PRIVACY"}</p>
      <h1 className="font-display text-6xl md:text-7xl leading-none">{isImp ? "IMPRESSUM" : "DATENSCHUTZ"}</h1>
      <div className="mt-12 whitespace-pre-wrap text-sm md:text-base leading-relaxed text-white/75">
        {text}
      </div>
    </div>
  );
}
